/*
 * @Description: 热点高程数据贴图渲染及部分下载
 * @Author: JokerShaw
 * @Date: 2023-07-24 09:53:52
 * @LastEditTime: 2023-08-01 09:09:41
 * @FilePath: \yd_yg_test_project_new\src\components\GlobeTool\HotSpotElevation\HotSpotElevation.jsx
 */

import React, { Component } from 'react'
import { connect } from 'react-redux';
import axios from 'axios'
import './HotSpotElevation.css'
import drawPolygon from '../statics/drawPolygon.png'
import { message, Spin } from 'antd'

class HotSpotElevation extends Component {
  constructor(props) {
    super(props)
    this.searchedRangePositionsString = {}
    this.state = {
      loading: false
    }
  }
  componentDidMount() {
    // console.log(this.props)
    // this.switchDisplayBoxVisibleStatus()
  }

  componentDidUpdate(preProps, preState) {
    if (preProps.visible !== this.props.visible) this.setState()
    if (preProps.selectedAreaPostions !== this.props.selectedAreaPostions) this.returnRangeJsonFromPolygon(this.props.selectedAreaPostions)
  }

  switchDisplayBoxVisibleStatus = () => {
    if (this.props.visible) {
      document.getElementById("hot-spot-elevation-display-box-wrap").style.display = "block"
    } else {
      document.getElementById("hot-spot-elevation-display-box-wrap").style.display = "none"
    }
  }
  // 获取查询所需的RangeJson
  returnRangeJsonFromPolygon = (positions) => {
    let rangeJson = { 'type': 'Polygon', 'coordinates': [] };
    let posList = [];
    positions.map((pos) => {
      posList.push(JSON.parse(pos));
    })
    // console.log('returnRangeJsonFromPolygon',positions)
    posList.push(JSON.parse(positions[0]));
    rangeJson.coordinates.push(posList);
    this.searchedRangePositionsString = JSON.stringify(rangeJson);
    // console.log('returnRangeJsonFromPolygon',rangeJsonString)
    // return rangeJsonString;
    console.log(this.searchedRangePositionsString)
  }

  downloadHotSpotElevation = async () => {
    let params = {
      time: new Date().getTime(),
      priority: 1,
      userId: this.props.user.userId,
      rangeJson: this.searchedRangePositionsString,
    }
    let documentFileName = params.time
    const { data: res } = await axios.post(`/zdTiles/api/getSparseElePointDataDownloadUrl`, params, {
      headers: {
        Authorization: this.props.zd_user.token,
      }
    })
    console.log(res)
    if (res.code === '0') {
      var url = res.data[documentFileName].replace('http://10.0.121.14:8084', '/zdTiles');
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true); // 异步
      xhr.responseType = 'blob'; // blob 类型
      xhr.onload = function () {
        if (xhr.status != 200) {
          alert('下载异常！');
          this.setState({ loading: false })
          return;
        }
        var newUrl = window.URL.createObjectURL(xhr.response);
        var a = document.createElement('a');
        a.setAttribute('href', newUrl);
        a.setAttribute('target', '_blank');
        a.setAttribute('download', documentFileName + '.txt'); // 自定义文件名（有效）
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
      xhr.send();
      this.setState({ loading: false })

    } else {
      message.error(res.info)
      this.setState({ loading: false })

    }
  }

  render() {
    return (
      <div className="hot-spot-elevation-display-box-wrap" style={{ display: this.props.visible ? 'block' : 'none' }}>
        <div className="hot-spot-elevation-display-box-header">高精度稀疏高程控制点下载</div>
        <div className="hot-spot-elevation-display-box-area-select-wrap">
          <img src={drawPolygon} className="hot-spot-elevation-display-box-area-select-button"></img>
          <div>点击鼠标左键开始绘制多边形，点击右键结束绘制</div>
        </div>
        <div className="hot-spot-elevation-display-box-seleced-area-range-wrap">
          <div className="hot-spot-elevation-display-box-seleced-area-range">{this.props.selectedAreaPostions}</div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="hot-spot-elevation-display-box-seleced-area-download" onClick={() => {
            this.setState({ loading: true })
            this.downloadHotSpotElevation()
          }}>下载</div>
        </Spin>
      </div>
    )
  }
}
const mapState = (state) => ({
  zd_user: state.userReducer.get('zd_user').toJS(),
  user: state.userReducer.get('user').toJS()
})

export default connect(mapState)(HotSpotElevation);